import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/api.service';
import { Observable } from 'rxjs';
import { IWorkLocation, IWorkLocationFilters } from './types';
import { IPagination } from '../../../../modules/authorization/store/types';
import { transformToFormData } from '../../../../utils/helpers/helpers';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class WorkLocationService {
    constructor(private apiService: ApiService) {}

    public fetchAll(data: IWorkLocationFilters): Observable<IPagination<IWorkLocation>> {
        return this.apiService.get(`/locations`, data);
    }

    public fetchOne(id: string): Observable<IWorkLocation> {
        return this.apiService.get(`/locations/${id}`);
    }

    public add(id: string, data: any): Observable<any> {
        return this.apiService.post(`/companies/${id}/locations`, transformToFormData(data, ['vat_verification_document']));
    }

    public update(id: string, data: any): Observable<any> {
        return this.apiService.put(`/locations/${id}`, transformToFormData(data, ['vat_verification_document']));
    }

    public delete(id: string): Observable<any> {
        return this.apiService.delete(`/locations/${id}`);
    }

    public bulkAction(action: string, ids: string[], active?: boolean): Observable<any> {
        return this.apiService.post(`/locations/bulk/${action}`, { ids, active });
    }

    public getLocationAddressByCoordinates(data: { lat: number; lon: number }): Observable<any> {
        return this.apiService.post(`/locations/location_address_for_gps/fetch`, data);
    }

    public getLocationCoordinatesByAddress(data: { country: string; city: string; postCode: string; street: string }): Observable<any> {
        return this.apiService.post(`/locations/location_gps_coordinates/fetch`, data);
    }

    public exportWorkLocationsToCSV(data: any): Observable<any> {
        return this.apiService.downloadGet(`/locations`, data);
    }

    public getLocationImportTemplate(companyId: string, data?: any) {
        return this.apiService.downloadPost(`/companies/${companyId}/locations/template`, data);
    }

    public importLocationsFromFile(companyId: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('location', file || '');
        return this.apiService.put(`/companies/${companyId}/locations/upload`, formData);
    }
}
